import React from "react";
import { Header } from "pwa-mmt-ui-header/ssr/header";

const ClientHeader = (props) => {
  const { data, localeSettings } = props
  const { globalConfig, multiLingualData } = data || {};
  const currencyChangeHandler = (currency) => {
    if (typeof window !== "undefined" && typeof URL === "function") {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("_uCurrency", currency);
      window.location.href = currentUrl.toString();
    }
  };
  return (
    <Header
      globalConfig={globalConfig || {}}
      hideExtraHeaderIcons
      multiLingualData={multiLingualData || {}}
      showCurrencySwitcher={false}
      localeSettings={localeSettings}
      onCurrencyChange={currencyChangeHandler}
    />
  );
};
export default ClientHeader;